/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import { updateSpotFiltersV2 } from "../../slices/spotFiltersSlice";

import AutoCompleteMultiSelectCheckboxList from "../common/AutoCompleteMultiSelectCheckboxList";
import types from "../../helpers/types";
import {convertFromCSVToArray, csvSelections } from "../../helpers/csvArrayAutoCompleteMultiSelectHelper";

import { useHistory } from "react-router-dom";

const SpotDestinationStateMultiFilter = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // We need a temp variable that handles an array of objects since the state is a CSV
  const [selectedDestinationStates, setSelectedDestinationStates] = useState([]);

  const stateDestinationStates = useSelector((state) => {
    return state.spotFilters.destinationState;
  });

  // When the state changes we need to refresh our auto-complete with the new array
  useEffect(() => {
    let arrayData = convertFromCSVToArray(stateDestinationStates, types.states);

    if(arrayData && arrayData.length > 0){
      setSelectedDestinationStates(arrayData);
    }
    else{
      setSelectedDestinationStates([]);
    }
  }, [stateDestinationStates]);

  // Only refresh the page on close so it doesn't refresh while clicking. Make sure to pass the CSV values not array values.
  const onClose = () => {
    let csvDestinationStatesVal = csvSelections(selectedDestinationStates);
    dispatch(
      updateSpotFiltersV2({
        filters: { destinationState: csvDestinationStatesVal},
        history,
      })
    );
  }

  // Update the temp variable as we see the autocomplete change
  const handleChange = (selectedDestinationStatesFromAutoComplete) => {
    setSelectedDestinationStates(selectedDestinationStatesFromAutoComplete);
  };

  return (
    <AutoCompleteMultiSelectCheckboxList
      label="Destination State"
      width={250}
      onClose={onClose}
      options={types.states}
      selectedOptions={selectedDestinationStates}
      setSelectedOptions={handleChange}
      autoCompleteTestId="spot-destination-state-multi-filter"
      cutDownLabels={false}
    />
  );
};

export default SpotDestinationStateMultiFilter;
